// Builds CSS that sets --type-color / --type-fg on any [data-subj] element whose
// subject contains one of a class type's keywords ("/" separates alternates).
// Earlier types in the list win when several match.
const HEX = /^#[0-9a-f]{6}$/i;
const esc = s => s.replace(/[\n\r\f]/g, " ").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
const fg = hex => {
  const n = parseInt(hex.slice(1), 16);
  const lum = 0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255);
  return lum > 160 ? "#2b2b2b" : "#ffffff";
};

export const typeKeywords = name => String(name || "").split("/").map(k => k.trim()).filter(Boolean);

export function buildClassTypeCss(types = []) {
  return types
    .filter(t => t && t.name && HEX.test(t.color || ""))
    .reverse()
    .map(t => {
      const sel = typeKeywords(t.name).map(k => `[data-subj][data-subj*="${esc(k)}" i]`).join(",");
      const pill = typeKeywords(t.name).map(k => `.event-pill[data-subj][data-subj*="${esc(k)}" i]`).join(",");
      return sel ? `${sel}{--type-color:${t.color};--type-fg:${fg(t.color)};}\n${pill}{background:${t.color};color:${fg(t.color)};}` : "";
    })
    .join("\n");
}
